/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState, useEffect, Fragment } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { SortableContent } from "components/sortable-content";
import { NewsItemSelectorWrapper } from "./news-item-selector-wrapper";
import { AddNewsItemButton } from "./add-news-item-button";
import { NewsItemDisplay } from "./news-item-display";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { cloneObjectsArray } from "utils/array";

// Featured Page Item Component
const FeaturedPageItem = ({ item, index, list, token, sortableMethods, updateItems, removeItem, onAddToFeaturedPages }) => {
    const guid = item?.guid;
    const webpageGuid = item?.webpage;
    const [webpage, setWebpage] = useState();
    const [loadingWebpage, setLoadingWebpage] = useState(false);

    // Load webpage if guid exists
    useEffect(() => {
        const load = async () => {
            if (webpageGuid && typeof webpageGuid === "string" && webpageGuid.length > 20) {
                setLoadingWebpage(true);
                try {
                    const webpageObj = await SimpliCityAdminSDK.webpage.findOne(token, webpageGuid);
                    setWebpage(webpageObj);
                } catch (e) {
                    setWebpage(undefined);
                } finally {
                    setLoadingWebpage(false);
                }
            } else {
                setWebpage(undefined);
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webpageGuid, token]);

    const onWebpageChange = (selectedWebpage) => {
        setWebpage(selectedWebpage);
        const nextPages = cloneObjectsArray(list);
        nextPages[index].webpage = selectedWebpage?.guid;
        updateItems(nextPages);
    };

    const onWebpageRemove = () => {
        setWebpage(undefined);
        const nextPages = cloneObjectsArray(list);
        nextPages[index].webpage = "";
        updateItems(nextPages);
    };

    return (
        <Fragment>
            <SortableContent
                id={guid}
                index={index}
                sortableMethods={sortableMethods}
            >
                <NewsItemSelectorWrapper
                    index={index}
                    webpage={webpage}
                    setWebpage={setWebpage}
                    webpageGuid={webpageGuid}
                    setWebpageGuid={(guid) => {
                        const nextPages = cloneObjectsArray(list);
                        nextPages[index].webpage = guid;
                        updateItems(nextPages);
                    }}
                    onSelectWebpage={onWebpageChange}
                    onWebpageRemoved={onWebpageRemove}
                    AddComponent={AddNewsItemButton}
                    DisplayComponent={NewsItemDisplay}
                    loadingWebpage={loadingWebpage}
                    setLoadingWebpage={setLoadingWebpage}
                    onAddToFeaturedPages={onAddToFeaturedPages}
                />
                <div>
                    <PositionButtons
                        index={index}
                        list={list}
                        handleUpdate={updateItems}
                    />
                    <RemoveIcon
                        className="simplicity-composer-field-editor-remove"
                        onDeleteItem={removeItem}
                        index={index}
                    />
                </div>
            </SortableContent>
        </Fragment>
    );
};

FeaturedPageItem.displayName = "FeaturedPageItem";
export { FeaturedPageItem };

